export default __webpack_public_path__ + "static/Play-Button-x2-9edac31aefdcc1e2018e844c8cf91e0f.png";